module.exports = __webpack_public_path__ + "img/nodata.7af3c6dc.png";